import styles from './NestedFormGroup.module.css';
import { createKeyValuePairs } from '../../../../_metronic/helpers/utils/utils';
import type { FormData, PageDataItem } from '../../../../_metronic/helpers/utils/types';

interface Props {
  parentIndex: number;
  heading: string;
  formData: FormData<any>[];
  setFormData: React.Dispatch<React.SetStateAction<FormData<any>[]>>;
  inputData: PageDataItem[];
}

const NestedFormGroup = ({ parentIndex, heading, formData, setFormData, inputData }: Props) => {
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    const [inputId, childIndex] = id.split('-');
    setFormData((prevData) => {
      const updatedData = [...prevData];
      updatedData[parentIndex].nested[childIndex][inputId] = value;
      return updatedData;
    });
  };

  const handleAddInputs = () => {
    setFormData((prevData) => {
      const updatedData = [...prevData];
      if (!updatedData[parentIndex].nested) {
        updatedData[parentIndex].nested = [];
      }
      updatedData[parentIndex].nested.push(createKeyValuePairs(inputData));
      return updatedData;
    });
  };

  const handleDeleteInputs = (index: number) => () => {
    setFormData((prevData) => {
      const updatedData = [...prevData];
      updatedData[parentIndex].nested.splice(index, 1);
      return updatedData;
    });
  };

  const getInputs = (childIndex: number) => {
    return inputData.map((field) => {
      const { id, label } = field;
      const key = `${id}-${childIndex}-${parentIndex}`;
      return (
        <div className={styles.inputWrap} key={field.id}>
          <label className={styles.label}>{label}</label>
          <input
            className={styles.input}
            id={key}
            placeholder={label}
            value={formData[parentIndex].nested[childIndex]?.[id] ?? ''}
            onChange={handleOnChange}
          />
        </div>
      );
    });
  };

  const getForm = () => {
    if (!formData[parentIndex].nested || formData[parentIndex].nested?.length == 0) {
      return (
        <div className={styles.form}>
          <h1 className={styles.title}>{heading}</h1>
        </div>
      );
    }

    return formData[parentIndex].nested.map((_, childIndex) => (
      <div className={styles.form} key={childIndex}>
        <h1 className={styles.title}>{`${heading} ${childIndex + 1}`}</h1>
        <div className={styles.section}>{getInputs(childIndex)}</div>
        <button
          className={`btn ${styles.deleteButton}`}
          type='button'
          onClick={handleDeleteInputs(childIndex)}
        >
          Delete this sub-group
        </button>
      </div>
    ));
  };

  return (
    <section className={styles.container}>
      <section className={styles.formWrap}>{getForm()}</section>
      <div className={`btn ${styles.addButton}`} onClick={handleAddInputs}>
        Add another sub-group
      </div>
    </section>
  );
};

export default NestedFormGroup;
